import React from 'react';
export function Footer() {
  return <footer className="w-full bg-pine" data-id="element-100" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl px-5 py-12 text-center" data-id="element-101" data-mp="3gezcj1s77n03">
        <h3 className="font-display text-3xl text-ember" data-id="element-102" data-mp="3ggka709t7m26">
          Solar PV &amp; Battery Diagnostic Pro
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-paper/70" data-id="element-103" data-mp="32m1et8sa9itd">
          The Split-and-Prove System for Every Solar, Inverter &amp; Battery
          Fault — split the system, prove the fault, then fix it.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-paper/70" data-id="element-104" data-mp="3991omvfnkca">
          <a href="mailto:[SUPPORT_EMAIL]" className="hover:text-paper hover:underline" data-id="element-105" data-mp="3lf58gu5i3vnz">
            [SUPPORT_EMAIL]
          </a>
          <a href="[INSTAGRAM_URL]" className="hover:text-paper hover:underline" data-id="element-106" data-mp="3qbvmlbxqwh6r">
            [@handle]
          </a>
          <a href="[SITE_URL]" className="hover:text-paper hover:underline" data-id="element-107" data-mp="2a19u3nmf7qxt">
            [www.site.com]
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-paper/15 pt-5 text-xs leading-relaxed text-paper/50" data-id="element-108" data-mp="3l9ac9f9lwy2u">
          Independent resource for qualified professionals. Not affiliated with
          or endorsed by any equipment manufacturer or standards body; brand
          names are used only to identify compatible equipment. NEC® and
          National Electrical Code® are registered trademarks of NFPA. Codes
          are cited by number and summarized, never reproduced: always check the
          edition adopted in your jurisdiction, follow the manufacturer&apos;s
          instructions and work within your license scope. Not a substitute for
          training, certification or the code itself. &copy; Solar PV &amp;
          Battery Diagnostic Pro 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}